export default __webpack_public_path__ + "faf69e7f589ee957de532e8cb887d209.svg";